import { combineReducers } from "redux";
import authReducer from "./authReducer";
import loginReducer from "./loginReducer";
import signupReducer from "./signupReducer";
import ForgotPassword from "./ForgotPassword";
import setupsettingReducer from "./setupsettingReducer";
import helpdeskAnnouncementReducer from "./helpdeskAnnouncementReducer";
import helpdeskSupportReducer from "./helpdeskSupportReducer";
import enquiryReducer from "./enquiryReducer";
import setuphospitalchargesReducer from "./setuphospitalchargesReducer";
import setuphospitalehrsettingReducer from "./setuphospitalehrsettingReducer";
import setuphospitalebedReducer from "./setuphospitalebedReducer";
import setuphospitalefrontofficeReducer from "./setuphospitalefrontofficeReducer";
import setuphospitaleoperationReducer from "./setuphospitaleoperationReducer";
import setuphospitalefindingReducer from "./setuphospitalefindingReducer";
import setuphospitalesymptomsReducer from "./setuphospitalesymptomsReducer";
import setuphospitalecomorbidityReducer from "./setuphospitalecomorbidityReducer";
import helpdeskAgentReducer from "./helpdeskAgentReducer";
import setuphospitalefinanceReducer from "./setuphospitalefinanceReducer";
import setuphospitalezoomsettingReducer from "./setuphospitalezoomsettingReducer";
import setuphospitalepharmacyReducer from "./setuphospitalepharmacyReducer";
import setuphospitaleradiologyReducer from "./setuphospitaleradiologyReducer";
import setuphospitalebloodbankReducer from "./setuphospitalebloodbankReducer";
import setuphospitalereferralReducer from "./setuphospitalereferralReducer";
import setuphospitalepathologyReducer from "./setuphospitalepathologyReducer";
import setuphospitaleinventoryReducer from "./setuphospitaleinventoryReducer";
import setuphrstaffbasicinformationReducer from "./setuphrstaffbasicinformationReducer";
import setuphospitaleappoinmetsettingReducer from "./setuphospitaleappoinmetsettingReducer";
import setuphospitaleprintingReducer from "./setuphospitaleprintingReducer";
import setuphospitleappointmentReducer from "./setuphospitleappointmentReducer";
import setuphospitaleopdOutReducer from "./setuphospitaleopdOutReducer";
import setuphospitaleprescriptionReducer from "./setuphospitaleprescriptionReducer";
import setuphospitaletpaReducer from "./setuphospitaletpaReducer";
import setuphospitalereferalpersonReducer from "./setuphospitalereferalpersonReducer";
import setuphospitaletimelineReducer from "./setuphospitaletimelineReducer";
import setuphospitalepaymentReducer from "./setuphospitalepaymentReducer";
import setuphospitaleopdchargeReducer from "./setuphospitaleopdchargeReducer";
import setuphospitaleopdoperationReducer from "./setuphospitaleopdoperationReducer";
import setuppharmacymedicineReducer from "./setuppharmacymedicineReducer";
import setuppurchesemedicineReducer from "./setuppurchesemedicineReducer";
import setuppharmacybillReducer from "./setuppharmacybillReducer";
import setuppharmacybadstockReducer from "./setuppharmacybadstockReducer";
import setuphospitalepathologytestReducer from "./setuphospitalepathologytestReducer";
import setuphospitalepathologybillReducer from "./setuphospitalepathologybillReducer";
import setuphospitaleradiologytestReducer from "./setuphospitaleradiologytestReducer";
import setuphospitaleradiologybillReducer from "./setuphospitaleradiologybillReducer";
import setuphospitalebloodbankdonorReducer from "./setuphospitalebloodbankdonorReducer";
import setuphospitaleambulanceReducer from "./setuphospitaleambulanceReducer";
import setuphospitalefrontofficephoneReducer from "./setuphospitalefrontofficephoneReducer";
import setuphospitaleipdReducer from "./setuphospitaleipdReducer";
import setuphospitaleipdinReducer from "./setuphospitaleipdinReducer";
import setuphospitalebirthrecordReducer from "./setuphospitalebirthrecordReducer";
import setuphospitaleincomeReducer from "./setuphospitaleincomeReducer";
import setupinventoryReducer from "./setupinventoryReducer";
import setuphospitaledownloadReducer from "./setuphospitaledownloadReducer";
import setuphospitalemessageReducer from "./setuphospitalemessageReducer";
import setuphrstaffattendanceReducer from "./setuphrstaffattendanceReducer";
import setuphospitaleprojectReducer from "./setuphospitaleprojectReducer";
import setuphospitaleliveconsaltationReducer from "./setuphospitaleliveconsaltationReducer";
import setuphospitalelivemeetingReducer from "./setuphospitalelivemeetingReducer";
import setuphospitalelivemeetingstaffReducer from "./setuphospitalelivemeetingstaffReducer";
import setuphospitaleproductgroupReducer from "./setuphospitaleproductgroupReducer";
import setuphospitalechannelpartnerReducer from "./setuphospitalechannelpartnerReducer";
import NewEnquiriesReducer from "./NewEnquiriesReducer";
import setuphospitaleaccountReducer from "./setuphospitaleaccountReducer";
import setuphospitaleleadReducer from "./setuphospitaleleadReducer";
import setuphospitaleleadtaskReducer from "./setuphospitaleleadtaskReducer";
import setuphospitaleleadcaseReducer from "./setuphospitaleleadcaseReducer";
import setupaccountbankReducer from "./setupaccountbankReducer";
import setupaccountcardReducer from "./setupaccountcardReducer";
import setupordersReducer from "./setupordersReducer";
import setuphospitaleproductordersReducer from "./setuphospitaleproductordersReducer";
import setupquotesReducer from "./setupquotesReducer";
import setupsalesordersReducer from "./setupsalesordersReducer";
import setupteamReducer from "./setupteamReducer";
import setupteammemberReducer from "./setupteammemberReducer";
import setupforecastReducer from "./setupforecastReducer";
import setuptimelineReducer from "./setuptimelineReducer";
import setuppatientidcardtemplateReducer from "./setuppatientidcardtemplateReducer";
import setupstaffcardtemplateReducer from "./setupstaffcardtemplateReducer";
import setupcertificatetemplateReducer from "./setupcertificatetemplateReducer";
import setuphospitaleipdoperationReducer from "./setuphospitaleipdoperationReducer";
import setupholidaydateReducer from "./setupholidaydateReducer";
import setupactivityReducer from "./setupactivityReducer";
import setupvacationReducer from "./setupvacationReducer";
import setuptaskReducer from "./setuptaskReducer";
import setupnoteReducer from "./setupnoteReducer";
import wheelchairRequestReducer from "./wheelchairRequestReducer";
import setuphospitaledietChartsettingReducer from "./setuphospitaledietChartsettingReducer";
import setuphospitaleexerciseChartsettingReducer from "./setuphospitaleexerciseChartsettingReducer";
import setuphospitaleimmunizationChartsettingReducer from "./setuphospitaleimmunizationChartsettingReducer";
import setuphospitaledutyrostershiftReducer from "./setuphospitaledutyrostershiftReducer";
import setupgeneralpainassessmentsettingReducer from "./setupgeneralpainassessmentsettingReducer";
import setuppediatricopdsettingReducer from "./setuppediatricopdsettingReducer";
import PediatricOpdReducer from "./PediatricOpdReducer";
import DentalOpdReducer from "./DentalOpdReducer";
import GeneralMedicineOpdReducer from "./GeneralMedicineOpdReducer";
import setupOpticShopReducer from "./setupOpticShopReducer";
import OpticShopOpdPurchaseItemReducer from "./OpticShopOpdPurchaseItemReducer";
import OpticShopOpdPrintReducer from "./OpticShopOpdPrintReducer";
import setupfrontofficepostalinwardoutwardReducer from "./setupfrontofficepostalinwardoutwardReducer";
import setupdentalopdReducer from "./setupdentalopdReducer";
import setupdentallabrecordReducer from "./setupdentallabrecordReducer";
import helpdeskTicketReducer from "./helpdeskTicketReducer";
import cartReducer from './cartReducer';
import knowledgeBaseReducer from "./knowledgeBaseReducer";
// import setupayurvedicReducer from "./setupayurvedicReducer";
import lostFoundReducer from "./lostFoundReducer";
import setupphysiotherapyReducer from "./setupphysiotherapyReducer";
import setupphysiotherapyOpdOutReducer from "./setupphysiotherapyOpdOutReducer";
import setupayurvedicReducer from "./setupayurvedicReducer";
import ayurvedicopdoutReducer from "./ayurvedicopdoutReducer";
import setupophthalmologyopdsettingReducer from "./setupophthalmologyopdsettingReducer";
import EyeOphthalmologyOpdReducer from "./EyeOphthalmologyOpdReducer";
import salesModuleReducer from './salesModuleReducer'
import TransactionReducer from './TransactionReducer'
import paymentGetwayReducer from './paymentGetwayReducer'
import setupAccountReducer from "./setupAccountReducer";
import PartyTypeReducer from "./PartyTypeReducer";
import setupProductAccountReducer from "./setupProductAccountReducer";
import GeneralLedgerReducer from "./GeneralLedgerReducer";
import customproductforaccountReducer from "./customproductforaccountReducer";
import setupsalespartytypeReducer from "./setupsalespartytypeReducer";
import setupSalesChannelReducer from "./setupSalesChannelReducer";
import setupcontactReducer from "./setupcontactReducer";
import setupproductdesignationReducer from "./setupproductdesignationReducer";
import setupChannelPartnerReducer from "./setupChannelPartnerReducer";
import channelPartnerPayoutReducer from "./channelPartnerPayoutReducer";
import setupproductnotificationReducer from "./setupproductnotificationReducer";
import channelPartnerCommissionLogReducer from "./channelPartnerCommissionLogReducer";
import frontofficeambulanceReducer from "./FrontofficeambulanceReducer";
import salesRefundReducer from "./salesRefundReducer";
import patientVisitReducer from "./patientVisitReducer";
import setupcommissionReducer from "./setupcommissionReducer";
import patientMasterReducer from "./patientMasterReducer";
import setuptaxmasterReducer from "./setuptaxmasterReducer";
import setupHRStaffSalaryAdvanceReducer from "./setupHRStaffSalaryAdvanceReducer";
import setupHRStaffLoanMasterReducer from "./setupHRStaffLoanMasterReducer";
import FinanceSetupReducer from "./FinanceSetupReducer";
import setuphospitalepatientvisitReducer from "./setuphospitalepatientvisitReducer";
import setuphospitalepatientprimaryvitalReducer from "./setuphospitalepatientprimaryvitalReducer";

import setuphospitalpackagechargesReducer from "./setuphospitalpackagechargesReducer";
export default combineReducers({
  val: authReducer,
  loginReducer: loginReducer,
  signupReducer: signupReducer,
  setupsettingReducer: setupsettingReducer,
  ForgotPassword: ForgotPassword,
  setuphospitalehrsettingReducer: setuphospitalehrsettingReducer,
  setuphospitalchargesReducer: setuphospitalchargesReducer,
  setuphospitalefrontofficeReducer: setuphospitalefrontofficeReducer,
  setuphospitaleoperationReducer: setuphospitaleoperationReducer,
  setuphospitalefindingReducer: setuphospitalefindingReducer,
  setuphospitalesymptomsReducer: setuphospitalesymptomsReducer,
  setuphospitalecomorbidityReducer: setuphospitalecomorbidityReducer,
  setuphospitalefinanceReducer: setuphospitalefinanceReducer,
  setuphospitalezoomsettingReducer: setuphospitalezoomsettingReducer,
  setuphospitalepharmacyReducer: setuphospitalepharmacyReducer,
  setuphospitalepathologyReducer: setuphospitalepathologyReducer,
  setuphospitaleradiologyReducer: setuphospitaleradiologyReducer,
  setuphospitalebloodbankReducer: setuphospitalebloodbankReducer,
  setuphospitalereferralReducer: setuphospitalereferralReducer,
  setuphospitaleinventoryReducer: setuphospitaleinventoryReducer,
  setuphospitalebedReducer: setuphospitalebedReducer,
  setuphrstaffbasicinformationReducer: setuphrstaffbasicinformationReducer,
  setuphospitaleappoinmetsettingReducer: setuphospitaleappoinmetsettingReducer,
  setuphospitaleprintingReducer: setuphospitaleprintingReducer,
  setuphospitleappointmentReducer: setuphospitleappointmentReducer,
  setuphospitaleprescriptionReducer: setuphospitaleprescriptionReducer,
  setuphospitaletpaReducer: setuphospitaletpaReducer,
  setuphospitalereferalpersonReducer: setuphospitalereferalpersonReducer,
  setuphospitaletimelineReducer: setuphospitaletimelineReducer,
  setuphospitleopdOutReducer: setuphospitaleopdOutReducer,
  setuphospitalepaymentReducer: setuphospitalepaymentReducer,
  setuphospitaleopdchargeReducer: setuphospitaleopdchargeReducer,
  setuphospitaleopdoperationReducer: setuphospitaleopdoperationReducer,
  setuppharmacymedicineReducer: setuppharmacymedicineReducer,
  setuppharmacybillReducer: setuppharmacybillReducer,
  setuppharmacybadstockReducer: setuppharmacybadstockReducer,
  setuppurchesemedicineReducer: setuppurchesemedicineReducer,
  setuphospitalepathologytestReducer: setuphospitalepathologytestReducer,
  setuphospitalepathologybillReducer: setuphospitalepathologybillReducer,
  setuphospitaleradiologytestReducer: setuphospitaleradiologytestReducer,
  setuphospitaleradiologybillReducer: setuphospitaleradiologybillReducer,
  setuphospitalebloodbankdonorReducer: setuphospitalebloodbankdonorReducer,
  setuphospitalefrontofficephoneReducer: setuphospitalefrontofficephoneReducer,
  setuphospitaleambulanceReducer: setuphospitaleambulanceReducer,
  setuphospitaleipdReducer: setuphospitaleipdReducer,
  setuphospitaleipdinReducer: setuphospitaleipdinReducer,
  setuphospitalebirthrecordReducer: setuphospitalebirthrecordReducer,
  setuphospitaleincomeReducer: setuphospitaleincomeReducer,
  setupinventoryReducer: setupinventoryReducer,
  setuphospitaledownloadReducer: setuphospitaledownloadReducer,
  setuphospitalemessageReducer: setuphospitalemessageReducer,
  setuphrstaffattendanceReducer: setuphrstaffattendanceReducer,
  setuphospitaleprojectReducer: setuphospitaleprojectReducer,
  setuphospitaleliveconsaltationReducer: setuphospitaleliveconsaltationReducer,
  setuphospitalelivemeetingReducer: setuphospitalelivemeetingReducer,
  setuphospitalelivemeetingstaffReducer: setuphospitalelivemeetingstaffReducer,
  setuphospitaleproductgroupReducer: setuphospitaleproductgroupReducer,
  setuphospitalechannelpartnerReducer: setuphospitalechannelpartnerReducer,
  NewEnquiriesReducer: NewEnquiriesReducer,
  setuphospitaleaccountReducer: setuphospitaleaccountReducer,
  setuphospitaleleadReducer: setuphospitaleleadReducer,
  setuphospitaleleadtaskReducer: setuphospitaleleadtaskReducer,
  setuphospitaleleadcaseReducer: setuphospitaleleadcaseReducer,
  setupaccountbankReducer: setupaccountbankReducer,
  setupaccountcardReducer: setupaccountcardReducer,
  setupordersReducer: setupordersReducer,
  setuphospitaleproductordersReducer: setuphospitaleproductordersReducer,
  setupquotesReducer: setupquotesReducer,
  setupsalesordersReducer: setupsalesordersReducer,
  setupteamReducer: setupteamReducer,
  setupteammemberReducer: setupteammemberReducer,
  setupforecastReducer: setupforecastReducer,
  setuptimelineReducer: setuptimelineReducer,
  setuppatientidcardtemplateReducer: setuppatientidcardtemplateReducer,
  setupstaffcardtemplateReducer: setupstaffcardtemplateReducer,
  setupcertificatetemplateReducer: setupcertificatetemplateReducer,
  setuphospitaleipdoperationReducer: setuphospitaleipdoperationReducer,
  setupholidaydateReducer: setupholidaydateReducer,
  setupactivityReducer: setupactivityReducer,
  setupvacationReducer: setupvacationReducer,
  setuptaskReducer: setuptaskReducer,
  setupnoteReducer: setupnoteReducer,
  setuphospitaledietChartsettingReducer: setuphospitaledietChartsettingReducer,
  setuphospitaleexerciseChartsettingReducer: setuphospitaleexerciseChartsettingReducer,
  setuphospitaleimmunizationChartsettingReducer: setuphospitaleimmunizationChartsettingReducer,
  setuphospitaledutyrostershiftReducer: setuphospitaledutyrostershiftReducer,
  physiotherapy: setupphysiotherapyReducer,
  setupgeneralpainassessmentsettingReducer: setupgeneralpainassessmentsettingReducer,
  setuppediatricopdsettingReducer: setuppediatricopdsettingReducer,
  PediatricOpdReducer: PediatricOpdReducer,
  setupphysiotherapyOpdOutReducer: setupphysiotherapyOpdOutReducer,
  setupayurvedicReducer: setupayurvedicReducer,
  ayurvedicopdoutReducer: ayurvedicopdoutReducer,
  setupophthalmologyopdsettingReducer: setupophthalmologyopdsettingReducer,
  setupdentalopdReducer: setupdentalopdReducer,
  DentalOpdReducer: DentalOpdReducer,
  GeneralMedicineOpdReducer: GeneralMedicineOpdReducer,
  setupOpticShopReducer: setupOpticShopReducer,
  OpticShopOpdPurchaseItemReducer: OpticShopOpdPurchaseItemReducer,
  OpticShopOpdPrintReducer: OpticShopOpdPrintReducer,
  EyeOphthalmologyOpdReducer: EyeOphthalmologyOpdReducer,
  setupdentallabrecordReducer: setupdentallabrecordReducer,
  cart: cartReducer,
  salesModule: salesModuleReducer,
  TransactionReducer: TransactionReducer,
  paymentGetwayReducer: paymentGetwayReducer,
  setupAccountReducer: setupAccountReducer,
  PartyTypeReducer: PartyTypeReducer,
  setupProductAccountReducer: setupProductAccountReducer,
  GeneralLedgerReducer: GeneralLedgerReducer,
  customproductforaccountReducer: customproductforaccountReducer,
  setupsalespartytypeReducer: setupsalespartytypeReducer,
  setupSalesChannelReducer: setupSalesChannelReducer,
  setupcontactReducer: setupcontactReducer,
  setupproductdesignationReducer: setupproductdesignationReducer,
  setupChannelPartnerReducer: setupChannelPartnerReducer,
  channelPartnerPayoutReducer: channelPartnerPayoutReducer,
  setupproductnotificationReducer: setupproductnotificationReducer,
  helpdeskAgent: helpdeskAgentReducer,
  helpdeskTicket: helpdeskTicketReducer,
  knowledgeBase: knowledgeBaseReducer,
  helpdeskAnnouncement: helpdeskAnnouncementReducer,
  setuptaxmasterReducer: setuptaxmasterReducer,
  setupHRStaffSalaryAdvanceReducer: setupHRStaffSalaryAdvanceReducer,
  setupHRStaffLoanMasterReducer: setupHRStaffLoanMasterReducer,
  helpdeskSupport: helpdeskSupportReducer,
  salesRefundReducer: salesRefundReducer,
  channelPartnerCommissionLogReducer: channelPartnerCommissionLogReducer,
  setupfrontofficepostalinwardoutwardReducer,
  lostFound: lostFoundReducer,
  enquiry: enquiryReducer,
  wheelchairRequest: wheelchairRequestReducer,
  frontofficeambulanceReducer: frontofficeambulanceReducer,
  patientVisit: patientVisitReducer,
  seetupcommissionReducer: setupcommissionReducer,
  patientMaster: patientMasterReducer,
  FinanceSetupReducer: FinanceSetupReducer,
  setuphospitalepatientvisitReducer: setuphospitalepatientvisitReducer,
  setuphospitalepatientprimaryvitalReducer: setuphospitalepatientprimaryvitalReducer,
  setuphospitalpackagechargesReducer: setuphospitalpackagechargesReducer,
});
